import { render, staticRenderFns } from "./page_type_translations_editor.vue?vue&type=template&id=9783e468&"
import script from "./page_type_translations_editor.vue?vue&type=script&lang=js&"
export * from "./page_type_translations_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports